import BasicRouteBuilder from 'Shared/utils/routeBuilder'

import { Routes } from './constants'

class SupplierRouteBuilder extends BasicRouteBuilder {
	// INJECT_FROM_PLOP_TABLELIST

	get document() {
		this.route += Routes.DOCUMENT
		return this
	}

	get dashboard() {
		this.route += Routes.DASHBOARD
		return this
	}

	get profile() {
		this.route += Routes.PROFILE
		return this
	}

	get report() {
		this.route += Routes.REPORT
		return this
	}

	get invoice() {
		this.route += Routes.INVOICE
		return this
	}

	get helpCenter() {
		this.route += Routes.HELP_CENTER
		return this
	}

	get registrationDocument() {
		this.route += Routes.REGISTRATION_DOCUMENT
		return this
	}

	get siteVisit() {
		this.route += Routes.SITE_VISIT
		return this
	}
}

const RouteBuilder = new SupplierRouteBuilder()

export default RouteBuilder
